// extracted by mini-css-extract-plugin
module.exports = {"grid-list":"_1XuUFY9_ggk7YrgkQaxkZ7","gridList":"_1XuUFY9_ggk7YrgkQaxkZ7"};